// services/route-tracker.service.ts
import { Injectable } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class RouteTrackerService {
  currentRoute = '';
  currentComponent = '';

  constructor(private router: Router, private activatedRoute: ActivatedRoute) {
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((event) => {
        this.currentRoute = event.urlAfterRedirects;
        this.currentComponent = this.getComponentName(this.activatedRoute);
      });
  }

  /** Walks the route tree to find the deepest activated component */
  private getComponentName(route: ActivatedRoute): string {
    let child = route;
    while (child.firstChild) {
      child = child.firstChild;
    }
    const component = child.component;
    if (!component) return 'Unknown';

    // component can be a class reference — get its name
    if (typeof component === 'function') {
      return component.name || 'Unknown';
    }
    return String(component);
  }
}